import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createTutorialPatients } from '@/features/internal/tutorial-patient/apis/tutorialPatient'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'

export const useCreateTutorialPatientsMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => createTutorialPatients(),
    onSuccess: () => {
      // 患者一覧を再取得（チュートリアル患者は本番一覧から除外されるが、整合のため invalidate）
      queryClient.invalidateQueries({
        queryKey: queryKeys.patients.all,
      })
    },
  })
}
